export default {
  'hero.title': 'AI 大模型解决方案',
  'hero.subtitle': 'AI+多产品，支撑企业降本提效',
  'hero.ctaPrimary': '立即咨询',
  'hero.ctaSecondary': '获取演示方案',
  'products.sectionTitle': 'AI+多产品，支撑企业降本提效',
  'products.rpa.title': 'AI+RPA',
  'products.rpa.description': '流程自动化，降本增效',
  'products.qa.title': 'AI+知识问答',
  'products.qa.description': '智能问答与知识库',
  'products.call.title': 'AI+外呼',
  'products.call.description': '自动外呼与电销',
  'scenarios.sectionTitle': '多场景，覆盖企业与客户联络的方方面面',
  'scenarios.assistant.title': 'WorkTool数字助手',
  'scenarios.assistant.description':
    'AI+RPA 自动化执行复杂任务，全流程编排与监控。',
  'scenarios.chatlink.title': 'ChatLink知识问答',
  'scenarios.chatlink.description':
    '知识库构建、检索增强问答、多渠道接入与运营。',
  'logoWall.sectionTitle': '深耕企业数智化',
  'cta.title': '工作效率交给我，创造空间留给你！',
  'cta.description': '我们为企业数字化转型提供一站式全生命周期服务',
  'cta.primaryText': '立即咨询',
  'cta.secondaryText': '获取演示方案',
};
